export default __webpack_public_path__ + "static/media/h2a3.60d81c92.jpg";